(() => {
  const banner = document.querySelector('[data-tt18-expiry]');
  if (!banner) return;
  const expiry = Date.parse(banner.dataset.tt18Expiry);
  if (!Number.isFinite(expiry)) return;
  let timer;
  const checkExpiry = () => {
    clearTimeout(timer);
    const remaining = expiry - Date.now();
    if (remaining <= 0) {
      banner.hidden = true;
      return;
    }
    timer = setTimeout(checkExpiry, Math.min(remaining + 50, 86400000));
  };
  checkExpiry();
  window.addEventListener('pageshow', checkExpiry);
  document.addEventListener('visibilitychange', checkExpiry);
})();
